import { render, staticRenderFns } from "./ItemMenuNew.vue?vue&type=template&id=9cf1d4de&scoped=true"
import script from "./ItemMenuNew.vue?vue&type=script&lang=js"
export * from "./ItemMenuNew.vue?vue&type=script&lang=js"
import style0 from "./ItemMenuNew.vue?vue&type=style&index=0&id=9cf1d4de&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf1d4de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cf1d4de')) {
      api.createRecord('9cf1d4de', component.options)
    } else {
      api.reload('9cf1d4de', component.options)
    }
    module.hot.accept("./ItemMenuNew.vue?vue&type=template&id=9cf1d4de&scoped=true", function () {
      api.rerender('9cf1d4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/ItemMenuNew.vue"
export default component.exports